import { useCallback } from "react";
import { useConfigurationModule } from "../../features/Settings/Configuration/hooks/useConfigurationModule";
import { getSettingsOrgResourceSearchFilters } from "../helpers/settings";

const ORG_LEVEL_FIELDS = ["id", "code", "description", "glSegment", "orgLevelGroup", "status"];
const ACTIVE_AND_INACTIVE = ["active", "inactive"];

// Org level filters in reports list inactive levels too when the company opts in.
export const useReportOrgLevelSearchFilters = () => {
	const includeInactive = Boolean(useConfigurationModule("reports.filters.includeInactiveOrgLevels"));

	return useCallback((search) => {
		if (!includeInactive) {
			return getSettingsOrgResourceSearchFilters(search);
		}
		return {
			...getSettingsOrgResourceSearchFilters(search, ORG_LEVEL_FIELDS),
			status: ACTIVE_AND_INACTIVE,
		};
	}, [includeInactive]);
};
